import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { PageService } from '../services/page.service';
import { Constants } from '../constants';
import { Dropdown } from 'primeng/dropdown';
import {F} from "@angular/cdk/keycodes";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, AfterViewInit {
  @ViewChild('adminPageSelect') adminPageSelect: Dropdown;

  dropdownVisible = false;
  get getDropdownIcon() { return this.dropdownVisible ? 'pi pi-caret-up' : 'pi pi-caret-down'; }

  isAdmin = false;

  $PageParams = this.pageService.$PageParams;
  $Pages = this.pageService.$existingPages;
  $pageSelected = this.pageService.$pageSelected;
  public hideLabel = false;
  pages = [];
  adminPages = [];
  selectedAdminPage: any = null;
  activePage: number;
  adminSelected: number;
  $headerPages = combineLatest([this.$PageParams, this.$pageSelected]).pipe(
    map(([pageParams, selected]) => {
      let activePage = {};
      let filterPages;
      if (pageParams === null && selected === null) {
        this.activePage = this.pages.find((y) => y.name === this.router.url)?.id;
      } else if (selected === null && !!pageParams) {
        this.activePage = pageParams;
      } else if (!!selected) {
        this.activePage = selected.id;
      }
      this.pages.sort((a, b) => a.position - b.position);
      // eslint-disable-next-line prefer-const
      filterPages = this.pages.filter(x => !x.isContentPage);
      return { pages: this.pages, filterPages };
    })
  );

  constructor(
    public authService: AuthService,
    public pageService: PageService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.authService.authenticated$.subscribe(result => {
      if (result && window.location.pathname !== '/login') {
        this.pageService.getPages().subscribe(
          {
            next: (x: any) => {
              this.pages = x;
              this.adminPages = this.pages.filter(x => !x.isContentPage || x.forAdmin);
              this.adminPages.forEach(ap => { ap.cssClass = 'my-class'; })
              if (this.activePage == null && !!this.route.snapshot.queryParamMap.get('pageName')) {
                const page = this.pages.find((y) => y.name === this.route.snapshot.queryParamMap.get('pageName'));
                this.activePage = page.id;
              } else {
                const page = this.pages.find((y) => this.router.url.includes(y.path));
                if (!!page && !page?.isContentPage) {
                  this.selectedAdminPage = page;
                }
              }
            },
            error: (error) => {

            },
            complete: () => { }
          });
      }
    });
  }

  ngAfterViewInit() {
    this.authService.getSavedRole().then((x) => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      x === Constants.CdfAdminRole ? this.isAdmin = true : this.isAdmin = false;
    });
  }

  logout() {
    this.authService.logout();
  }

  goto(page: any) {
    //console.log('Goto called with page:', page);
    if (!!page) {
      if (page.isContentPage && !page.forAdmin) {
        this.pageService.$pageSelected.next(page);
        this.selectedAdminPage = null;
        this.hideLabel = true;
        //console.log('Navigating to content page:', page.path);
        this.router.navigate([`${page.path}`], {
          queryParams: { pageId: null, contentId: null, pageName: page.name },
          queryParamsHandling: 'merge'
        });
      } else {
        this.hideLabel = true;
        this.selectedAdminPage = page;
        this.pageService.$pageSelected.next(page);
        this.authService.setSelectedPage(page);
        //need this because we have content with : forAdmin = true and isContentPage = true
        if (page.isContentPage) {
          //console.log('Navigating to admin content page:', page.path);
          this.router.navigate([`${page.path}`], {
            queryParams: { pageId: null, contentId: null, pageName: page.name },
            queryParamsHandling: 'merge'
          });
        } else {
          //console.log('Navigating to admin page:', page.path);
          this.router.navigate([page.path]);
          //console.log('finish Navigating to admin page:', page.path);
        }
      }
    }
  }

  onAdminPageChange(event) {
    // When an admin page is selected from the dropdown
    //console.log('Admin page selected:', event);
    if (event && event.value) {
      //console.log('Navigating to:', event.value);
      // Navigate to the selected page
      this.goto(event.value);
    }
  }

  setText(value: string) {
    return value.toUpperCase();
  }

  goHomeKey(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.goHome();
    }
  }

  goHome() {
    let page = this.pages.find(x => x.name === 'Home');
    this.goto(page);
  }

  protected readonly F = F;
}
